<template>
  <div class="modal__BuilderBlockWrapper" v-if="block.type === 'repository'">
    <p>
      <label class="formLabel" :for="`repository`">{{ $store.getters.getStringTranslation('attachemntsTitle') }}</label>
      <input :id="`repository`" class="formInput" type="text" v-model="block.title" />
    </p>

    <ul class="modal__BuilderResources">
      <li class="modal__BuilderResourcesItem" v-for="(file, index) in block.files" :key="`file-${index}`">
        <button class="modal__BuilderResourcesIcon" @click="moveResource(index, index - 1, block.files)">
          <icon name="arrow-up"></icon>
        </button>
        <button class="modal__BuilderResourcesIcon" @click="moveResource(index, index + 1, block.files)">
          <icon name="arrow-down"></icon>
        </button>
        <input v-model="file.filename" type="text" class="formInput--Repository" />
        <button class="modal__BuilderResourcesIcon--Delete" @click="removeFile(file)">
          <icon weight="regular" name="times"></icon>
        </button>
      </li>
    </ul>

    <div class="formUpload--Resources">
      <input
        class="formUpload__Input"
        type="file"
        name=""
        id="file"
        accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint, application/pdf"
        @change="readFile"
      />
      <label for="file" class="formUpload__Label">
        <template v-if="file.name === undefined">
          <span>{{ $store.getters.getStringTranslation('dragAndDrop') }}</span>
          <strong>{{ $store.getters.getStringTranslation('chooseFileToUpload') }}</strong>
        </template>
        <template v-else>
          {{ file.name }}
        </template>
      </label>
    </div>
  </div>
</template>

<script>
import HTTP from '@/http-common.js'
import MoveResource from '@/components/mixins/MoveResource.js'

export default {
  props: ['block', 'apiKeys', 'status'],
  mixins: [MoveResource],
  data() {
    return {
      file: {},
    }
  },
  methods: {
    removeFile(file) {
      if (!confirm('Are you sure?')) {
        return
      }
      this.updating = true

      if (file.uuid) {
        HTTP.post(`/private_upload/${file.uuid}/delete`, { api_keys: this.apiKeys })
          .then(() => {
            this.updating = false
            this.block.files.splice(this.block.files.indexOf(file), 1)
          })
          .catch((e) => {
            this.errors = e.response ? e.response.data : console.error(e)
            this.updating = false
          })
      } else {
        this.block.files.splice(this.block.files.indexOf(file), 1)
        this.updating = false
      }
    },
    readFile(event) {
      const input = event.target
      this.errors = []
      if (input.files && input.files[0]) {
        // Create a new FileReader to read file
        const reader = new FileReader()

        reader.onload = () => {
          this.file = input.files[0]
          this.uploader()
        }
        reader.readAsBinaryString(input.files[0])
      } else {
        this.errors = 'Something went wrong!'
      }
    },
    uploader() {
      this.updating = true

      let formData = new FormData()
      formData.append('file', this.file)
      formData.append('org_id', this.$store.state.accounts.user.org_id)
      formData.append('hidden', false)

      this.apiKeys.forEach((apiKey) => {
        formData.append(`api_keys[]`, apiKey)
      })

      let status = 'upload'
      if (!this.$route.params.id && this.status === 'password_protected') {
        alert('To use private attachemtns please publish a post first.')
        return
      }
      if (this.status === 'password_protected') {
        status = 'private_upload'
        formData.append('resource_id', this.$route.params.id)
      }

      HTTP.post(status, formData)
        .then((response) => {
          // Load data, set type to scraper type
          this.updating = false

          if (this.status === 'password_protected') {
            this.block.files.push({
              filename: response.data.name,
              url: response.data.url,
              uuid: response.data.uuid,
            })
          } else {
            this.block.files.push({
              filename: response.data.name,
              url: response.data.url,
            })
          }

          this.file = {}
        })
        .catch((e) => {
          this.errors = e.response ? e.response.data : console.error(e)
          this.updating = false
        })
    },
  },
}
</script>
